module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/3_b0440e4ccd80ca2fef224adaf3e87a10.png";